import { render, staticRenderFns } from "./TableBalanceCurrentSMS.vue?vue&type=template&id=a0faa6e8&"
import script from "./TableBalanceCurrentSMS.vue?vue&type=script&lang=js&"
export * from "./TableBalanceCurrentSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports